<template>
    <button
        type="button"
        class="hover:bg-muval-gray-6 flex h-10 w-full items-center gap-x-2 px-4"
        :aria-expanded="open"
        @click="open = !open"
    >
        <span class="text-muval-gray-2 text-xs font-medium tracking-wide uppercase">My work</span>
        <!-- Like the other groups, a closed group still shows what is waiting inside it -->
        <span
            v-if="!open && count"
            data-test="my-work-count"
            class="bg-brand flex size-[18px] items-center justify-center rounded-full text-xs font-bold text-white"
        >
            {{ count }}
        </span>
        <span class="ml-auto flex items-center gap-x-2">
            <span
                v-if="onShift"
                data-test="on-shift"
                class="bg-muval-green-4 text-muval-green-3 flex items-center gap-x-1 rounded-full px-2 py-0.5 text-xs font-medium"
            >
                <span class="bg-muval-success size-1.5 rounded-full" />
                On shift
            </span>
            <SvgIcon
                name="system-chevron-up"
                class="text-muval-gray-2 size-5 transition"
                :class="!open && 'rotate-180'"
            />
        </span>
    </button>
</template>

<script setup lang="ts">
import { useOnShift } from '@/composables/useOnShift';

const open = defineModel<boolean>('open', { required: true });

defineProps<{ count?: number }>();

const onShift = useOnShift();
</script>
